
import { cookie } from "@assets/svg";
import "./cookies.css";
import { BrowserCustomerClient } from "@client";
import { CookieInputModel } from "@models/api";
import { useNavigate } from "@remix-run/react";

export default function CookiePreference({ deviceId, isMobile, onSelection }: { deviceId: string, isMobile: boolean, onSelection: () => void }) {

    const handlePreference = async (preference: boolean) => {
        const reqBody: CookieInputModel = {
            did: deviceId,
            isAccepted: preference
        }

        const client = new BrowserCustomerClient();
        await client.SetCookieStatus(reqBody);
        onSelection();
    }

    const navigate = useNavigate();
    const handlePolicyClick = () => {
        navigate("/privacy");
    }

    return (
        <>
            {
                !isMobile ?
                    <div className="d-cookie-div fixed bottom-10 z-50">
                        <img src={cookie} alt="cookie" />
                        <p className="d-cookie-text">  Our website uses cookies. By continuing to navigate, we assume your permission to deploy cookies as detailed in our <span className="cursor-pointer underline" onClick={handlePolicyClick}>Privacy Policy</span>. </p>
                        <div className="d-cookie-cta-div">
                            <button className="accept-cta" onClick={() => handlePreference(true)}> Accept </button>
                            <button className="manage-cta" onClick={() => handlePreference(false)}> Reject </button>
                        </div>
                    </div>
                    :
                    <div className="m-cookie-div fixed bottom-10 z-50 ">
                        <div className="m-cookie-content">
                            <img src={cookie} alt="cookie" />
                            <p className="m-cookie-text">  Our website uses cookies. By continuing to navigate, we assume your permission to deploy cookies as detailed in our <span className="underline" onClick={handlePolicyClick}>Privacy Policy</span>. </p>
                        </div>

                        <div className="m-cookie-cta-div">
                            <button className="accept-cta" onClick={() => handlePreference(true)}> Accept </button>
                            <button className="manage-cta" onClick={() => handlePreference(false)}> Reject </button>
                        </div>
                    </div>
            }
        </>
    )
}
